export const formatHeader = (
  typeOfChange: string | undefined,
  updateCycleCount: number,
): string => {
  const now = new Date();
  const nowFormatted = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;

  return `\x1B[1m${nowFormatted} \x1B[32;4mRHF state update ${
    typeOfChange ? `(${typeOfChange})` : ""
  }\x1B[m \x1B[1;34m#${updateCycleCount}\x1B[m\n`;
};
